import { render, staticRenderFns } from "./AddPageClassDialog.vue?vue&type=template&id=667363a8&scoped=true"
import script from "./AddPageClassDialog.vue?vue&type=script&lang=js"
export * from "./AddPageClassDialog.vue?vue&type=script&lang=js"
import style0 from "./AddPageClassDialog.vue?vue&type=style&index=0&id=667363a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667363a8",
  null
  
)

export default component.exports